import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const GroupBrandDetailsPage = withSuspense(
	lazy(async () => await import('./group-brand-details-page.component')),
	PageLoader,
);
